/*
 *
 * ProfileAmbassador reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_PLANS_FAILED,
  GET_PLANS_SUCCESS,
  GET_PLANS_WATCHER,
  UPDATE_PHOTO_WATCHER,
  UPDATE_PHOTO_SUCCESS,
} from "./constants"

export const initialState = fromJS({
  loadingPlans: false,
  plans: [],
  ambassador: {},
  filter: [],
  divisions: [],
  count_action_plans: 0,
  loadingPhoto: false,
  leader_team: [],
  current_user_can_action: false,
})

function profileAmbassadorReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_PHOTO_WATCHER:
      return state.set("loadingPhoto", true)

    case UPDATE_PHOTO_SUCCESS:
      return state.set("loadingPhoto", false)

    case GET_PLANS_WATCHER:
      return state.set("loadingPlans", true).set("count_action_plans", 0)
    case GET_PLANS_SUCCESS:
      return state
        .set("loadingPlans", false)
        .set("plans", action.payload.plans)
        .set("divisions", action.payload.divisions)
        .set("count_action_plans", action.payload.count_action_plans)
        .set("leader_team", action.payload.leader_team)
        .set("current_user_can_action", action.payload.current_user_can_action)
        .set(
          "ambassador",
          Array.isArray(state.get("ambassador"))
            ? state.get("ambassador").length === 0
              ? action.payload.ambassador
              : state.get("ambassador")
            : action.payload.ambassador
        )
        .set(
          "filter",
          Array.isArray(state.get("filter"))
            ? state.get("filter").length === 0
              ? action.payload.filter
              : state.get("filter")
            : action.payload.filter
        )
    case GET_PLANS_FAILED:
      return state.set("loadingPlans", false).set("plans", [])
    default:
      return state
  }
}

export default profileAmbassadorReducer
